import * as fetchingApi from '@services/fetchingApi'
import { webApiBuildUrl } from '@api/utils'

export const getAddresses = (cityId, term) =>
    fetchingApi.Get(webApiBuildUrl(`api/order/addresses/${cityId}?text=${term}`))
export const getAddressById = (shipAddressId) =>
    fetchingApi.Get(webApiBuildUrl(`api/order/addresses/addressId/${shipAddressId}`))
export const createFromPreorderWithERecipe = (data) =>
    fetchingApi.Post(webApiBuildUrl('api/order/createFromPreorderWithERecipe'), data)
// eslint-disable-next-line max-len
export const getStocksGoods = (cityId, goodIds) =>
    fetchingApi.Post(webApiBuildUrl(`api/order/stock/get-stocks-goods/${cityId}`), goodIds)
export const getOrderFullInfo = (orderId, ctx) => fetchingApi.Get(webApiBuildUrl(`api/order/${orderId}/full-info`), ctx)
export const getOrder = async (orderId) => fetchingApi.Get(webApiBuildUrl(`api/order/${orderId}`))
// eslint-disable-next-line max-len
export const getOrderItems = async (orderId, shipment, ctx) =>
    fetchingApi.Post(webApiBuildUrl(`api/order/${orderId}/goods`), shipment, ctx)

// preorder
// eslint-disable-next-line max-len
export const getPreorderFullInfo = async (preorderUid, ctx) =>
    fetchingApi.Get(webApiBuildUrl(`api/order/preorders/GetPreorderFullInfo?preorderUid=${preorderUid}`), ctx)
// eslint-disable-next-line max-len

export const logOrderCheckCert = async ({ preorderUid = null, isTrustCertificate = false }) =>
    fetchingApi.Post(webApiBuildUrl(`api/order/log/order-check-certs`), { preorderUid, isTrustCertificate })

export const getThreshold = async () => fetchingApi.Get(webApiBuildUrl('api/order/threshold'))
